import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { FileText, Check, Loader2, PartyPopper } from "lucide-react";
import { useBuyGuide } from "@/components/jobbkarta/useBuyGuide";

const POINTS = [
  "Konkret tidslinje: när och hur ofta du följer upp",
  "Färdiga mallar för uppföljningsmejl – med ämnesrader",
  "Hur du avslutar snyggt och håller dörren öppen",
];

const VARIANTS = {
  "post-send": {
    icon: PartyPopper,
    title: "Snyggt – ansökan är på väg!",
    description: (
      <>
        Nu avgör uppföljningen. Vår <b>Uppföljningsguide</b> ger dig en färdig plan och
        mejlmallar för att faktiskt få svar.
      </>
    ),
  },
  info: {
    icon: FileText,
    title: "Uppföljningsguiden (PDF)",
    description: (
      <>
        En komplett guide om hur du följer upp efter en spontanansökan – med en konkret plan
        och färdiga mejlmallar som hjälper dig att faktiskt få svar.
      </>
    ),
  },
};

export default function GuideOfferDialog({ open, onOpenChange, variant = "post-send" }) {
  const { buy, loading } = useBuyGuide();
  const v = VARIANTS[variant] || VARIANTS["post-send"];
  const Icon = v.icon;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="guide-offer-dialog">
        <DialogHeader>
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-emerald-100 text-emerald-700">
            <Icon className="h-6 w-6" />
          </div>
          <DialogTitle className="text-center font-display text-xl">{v.title}</DialogTitle>
          <DialogDescription className="text-center text-sm">{v.description}</DialogDescription>
        </DialogHeader>

        <ul className="space-y-2 rounded-2xl border border-emerald-100 bg-emerald-50/60 p-4">
          {POINTS.map((p, i) => (
            <li key={i} className="flex items-start gap-2 text-sm text-slate-700">
              <Check className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" />
              <span>{p}</span>
            </li>
          ))}
        </ul>

        <div className="flex items-center justify-between rounded-xl bg-slate-50 px-4 py-2 text-sm">
          <span className="text-slate-500">Engångsköp · direkt nedladdning</span>
          <span className="font-display text-lg font-extrabold text-slate-900">89 kr</span>
        </div>

        <Button
          onClick={buy}
          disabled={loading}
          data-testid="offer-buy-guide-btn"
          className="w-full gap-2 rounded-full bg-emerald-600 text-base hover:bg-emerald-700"
        >
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileText className="h-4 w-4" />}
          Köp Uppföljningsguiden – 89 kr
        </Button>
        <p
          data-testid="offer-no-withdrawal-note"
          className="mt-2 text-center text-xs leading-relaxed text-slate-500"
        >
          Detta är en digital produkt som levereras direkt. Genom att köpa godkänner du att
          leveransen påbörjas omedelbart och att <b className="text-slate-700">ångerrätten
          därmed inte gäller</b> – köpet kan inte ångras eller återbetalas. Se våra{" "}
          <a
            href="/kopvillkor"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-emerald-700 underline hover:text-emerald-800"
          >
            köpvillkor
          </a>
          .
        </p>
        <button
          onClick={() => onOpenChange(false)}
          data-testid="offer-dismiss-btn"
          className="mx-auto mt-1 block text-xs text-slate-400 hover:text-slate-600"
        >
          Nej tack, kanske senare
        </button>
      </DialogContent>
    </Dialog>
  );
}
